<template src="./CouponAssociation.html" />

<script>
import { computed } from "vue"
import { useStore } from "@/store/store.js"
import mixins from "@/Mixins.js"
import WholeMultiselect from "@/components/whole-multiselect/WholeMultiselect.vue"
import ExportReport from "@/components/export-report/ExportReport.vue"

export default {
  name: "CouponAssociation",
  mixins: [mixins],
  components: { WholeMultiselect, ExportReport },
  data () {
    return {
      editMode: false,

      aasList: [],
      aasSelected: null,
      aasInvalid: false,

      couponList: [],
      couponSelected: [],
      couponInput: [],
      couponOptions: [],
      couponInvalid: false,
      
      associationList: [],

      showModalAssociation: false,
      status: true,
      currentPage: 1,
      numPages: 0,
      search: "",

      keyStamp: null,
      filterFunction: null,
    };
  },

  computed: {
    modalTitle () {
      return `${this.editMode ? 'Editar' : 'Nova'} associação de cupom`
    },
    isPaginated () {
      return this.numPages > 1
    }
  },
  
  setup () {
    const store = useStore()

    return {
      urlServer: computed(() => store.state.filooServer),
      isMobile: computed(() => store.getters.isMobile),
    }
  },

  async mounted () {
    await this.getPlans()
    await this.getAAS()
    await this.getAasCouponAssociation()
  },
  methods: {
    handleCreateAssociation () {
      this.clearAllFields()

      this.editMode = false
      this.showModalAssociation = true
      this.status = true

      this.setCouponOptions()
    },
    handleeditMode(association) {
      this.clearAllFields()
      
      this.editMode = true
      this.showModalAssociation = true
      this.status = association.status

      this.aasSelected = {
        id: association.userAasId,
        name: association.userAasName,
      }

      this.couponSelected = association.planCupom.map((item) => ({
        id: item.planId,
        name: this.couponList.find((c) => c.id === item.planId).name
      }))      
      
      this.setCouponOptions()
    },
    async handleSelectCouponAdd (coupon) {
      await this.couponSelected.push(coupon)

      this.setCouponOptions()
      this.couponInput = null
    },
    async handleSelectCouponRemove (coupon) {
      const index = this.couponSelected.findIndex((c) => c.id === coupon.id)

      if (index >= 0) {
        await this.couponSelected.splice(index, 1)

        this.setCouponOptions()
      }
    },
    clearAllFields () {
      this.aasSelected = null
      this.couponOptions = []
      this.couponListShow = []
      this.couponSelected = []

      this.aasInvalid = false
      this.couponInvalid = false
    },
    setCouponOptions () {
      const selection = this.couponSelected.length
        ? this.couponSelected.map((c) => c.id)
        : []

      this.couponOptions = this.couponList.filter((c) => !selection.includes(c.id))
    },
    validateFields () {
      if (!this.aasSelected || !this.aasSelected.id || !this.aasSelected.name) {
        this.aasInvalid = true
      }
      if (!this.couponSelected.length) {
        this.couponInvalid = true
      }

      if (this.aasInvalid || this.couponInvalid) {
        this.$vs.notify({
          title: "Atenção!",
          text: "Campos obrigatórios não preenchidos ou inválidos.",
          color: "warning",
          icon: "error",
          position: "top-right",
          time: 4000,
        });
      } else {
        this.saveAssCouponAssociation()
      }
    },
    async saveAssCouponAssociation () {
      const bearer = this.$session.get("bearer")
      const aasCouponAssociation = {
        plans: this.couponSelected.map((c) => c.id),
        status: this.status,
        userAasId: this.aasSelected.id,
      }
      
      const response = this.editMode
        ? await this.axios.put(
            `${this.urlServer}aas/plans`,
            aasCouponAssociation,
            { headers: { Authorization: bearer }}
          )
        : await this.axios.post(
            `${this.urlServer}aas/plan`,
            aasCouponAssociation,
            { headers: { Authorization: bearer }}
          )

      this.showModalAssociation = false

      if (response && response.status === 200) {
        this.getAasCouponAssociation()
        const txt = this.editMode ? "foi alterada" : "criada"

        this.$swal(
          "Operação realizada",
          `A associação ${txt} com sucesso!`,
          "success"
        )
      } else {
        this.$swal(
          "Atenção!",
          `Não foi possível realizar esta operação. Por favor contacte o
            administrador do sistema`,
          "error"
        );
      }
    },
    getPlans () {
      this.axios.get(
        `${this.urlServer}customerplan/all-plans`,
        { headers: { Authorization: this.$session.get("bearer") }}
      )
        .then(({ status, data }) => {
          if (status === 200) {
            this.couponList = data.map((item) => ({
              id: item.id,
              name: `${item.name}  (${item.code})`,
            }))
          }
        })
        .catch(() => {
          this.$swal({
            title: "Atenção!",
            text: `Não foi possível listar os planos, contacte o administrador
              do sistema.`,
            icon: "error",
          })
        })
    },
    getAAS () {
      this.axios.get(
        `${this.urlServer}aas/users-all`,
        { headers: { Authorization: this.$session.get("bearer") }}
      )
        .then(({ status, data }) => {
          if (status === 200) {
            this.aasList = data.map((item) => ({
              id: item.id,
              name: item.user.name,
            }))
          }
        });
    },
    getAasCouponAssociation () {
      const search = this.search
      const query = `size=10&page=${this.currentPage - 1}&search=${search}`

      this.axios.get(
        `${this.urlServer}aas/plans?${query}`,
        { headers: { Authorization: this.$session.get("bearer") }}
      )
        .then(({ status, data }) => {
          if (status === 200) {
            this.numPages = data.totalPages
            this.associationList = data.content.map((item) => ({
              ...item,
              userAasName: item.userAasName || "Sem registro",
            }))
          }
        })
    },
    async handleToggleStatus ({ planCupom, userAasId, userAasName, status}) {
      await this.clearAllFields()

      this.editMode = true
      this.couponSelected = planCupom.map((i) => ({ id: i.planId, name: i.name}))
      this.aasSelected = { id: userAasId, name: userAasName }
      this.status = !status

      this.saveAssCouponAssociation()
    },
    filterAasCouponsAssociation (search) {
      const oldStamp = this.keyStamp
      this.keyStamp = new Date().getTime()

      if (this.keyStamp - oldStamp < 300) {
        clearTimeout(this.filterFunction)
      }
      
      this.filterFunction = setTimeout(() => {
        this.currentPage = 1
        this.search = search
        this.getAasCouponAssociation()
      }, 500)
      
    },
  },
  watch: {
    aasSelected () {
      this.aasInvalid = false
    },
    couponSelected () {
      this.couponInvalid = false
    },
    currentPage () {
      this.getAasCouponAssociation()
    },
  },
};
</script>

<style lang="scss" src="./CouponAssociation.scss" scoped />
